import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Capacity, CapacityHour } from '../models/capacity.model';
import { MenuItemBookDetail } from '../models/rich-data.model';
import { ToastMachineService } from './toast-machine.service';

@Injectable({
  providedIn: 'root'
})
export class ReservationService {

  tableNo: string = null;

  constructor(
    private http: HttpClient,
    private toaster: ToastMachineService
  ) { }

  controlReservationLimit(bookDetailId: number, date: string): Promise<number | string> {
    return new Promise((resolve, reject) => {
      this.http.get(`${environment.apiURL}/remaining_limit/${bookDetailId}/${date}`).subscribe({
        next: (resp: number | string) => {
          resolve(resp);
        },
        error: err => {
          const error = err.error && err.error.message ? err.error.message : err.message;
          this.toaster.toastMachine(error, 'danger', 3000);
          reject(err);
        }
      });
    });
  }

  getCapacityHours(
    menuItemBookDetail: MenuItemBookDetail,
    reservationDate: Date,
    bookPax: number,
    duration: number
  ): Promise<CapacityHour[]> {
    return new Promise((resolve, reject) => {

      const DATA = {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        menu_item_id: menuItemBookDetail.menu_item_id,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        menu_item_book_detail_id: menuItemBookDetail.id,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        reservation_date: reservationDate,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        reservation_duration: duration
      };

      this.http.post(`${environment.apiURL}/check_reservation_availability`, DATA).subscribe({
        next: (resp: Capacity[]) => {

          resp ||= [];

          resp.forEach(table => {
            table.hours = table.hours.filter(hour => hour.limit > 0 && hour.limit >= bookPax);
          });

          const NEWDATA = [...new Set(resp.reduce((acc, curr) => {
            curr.hours = curr.hours.map(hour => {
              hour.capacityIds = [curr.capacity_id];

              return hour;
            });

            for (const hour of curr.hours) {
              const HOUR = acc.find(x => x.hour === hour.hour);

              if (HOUR) {
                HOUR.capacityIds.push(curr.capacity_id);
              } else {
                acc.push(hour);
              }
            }

            return acc;
          }, [] as CapacityHour[]))].sort((a, b) => a.hour.localeCompare(b.hour));



          resolve(NEWDATA);
        },
        error: err => {
          const error = err.error && err.error.message ? err.error.message : err.message;
          this.toaster.toastMachine(error, 'danger', 3000);
          reject(err);
        }
      });
    });
  }

}
